module.exports = __webpack_public_path__ + "b88fd4a74bbd246f777b04eaa7fe6aae.svg";